import GSocialShare from './g-social-share.vue';

export default GSocialShare;
